import React from 'react';
import './button.scss';


const MainButton = ({
  text,
  variant,
  onClick = () => {},
  icon,
  textStyle,
  disabled,
  link = false,
  href = ''

}) => {
  return (
    <button
    disabled={disabled}
    onClick={onClick}
    className={`btn-same button-mainprimary`}
  >
    <div className={`button-${textStyle}`}>{text}</div>
  </button>
  );
};

export default MainButton;
